const zh = {
  "hotel.folio.guest": "住客",
  "hotel.folio.guest.name": "姓名",
  "hotel.folio.guest.birthday": "出生日期",
  "hotel.folio.guest.id_number": "身份证号码",
  "hotel.folio.guest.sex": "性别",
  "hotel.folio.guest.nationality": "国籍",
  "hotel.folio.guest.target_country": "目的地国家",
  "hotel.folio.guest.email": "电子邮箱",
  "hotel.folio.guest.Nombres": "全名",
  "hotel.folio.guest.typeDocument": "证件类型",
  "hotel.folio.guest.type_accomodation": "住宿类型",
  "hotel.folio.guest.room": "房间",
  "hotel.folio.guest.phone": "电话",
  "hotel.folio.guest.arrival_date": "入住日期",
  "hotel.folio.guest.departure_date": "退房日期",
  "hotel.folio.guest.nights_quantity": "入住晚数",
  "hotel.folio.guest.unit_price": "房价 / 单价",
  "hotel.folio.guest.payment_status": "付款状态",
  "hotel.folio.guest.channel": "预订渠道",
  "hotel.folio.guest.reason": "出行原因",
  "hotel.folio.guest.Tipo de Ocupante": "入住者类型",
  "hotel.folio.guest.company": "公司",
  "hotel.folio.guest.Identificación Empresa": "公司识别号",
  "hotel.folio.guest.vehicle_plate": "车牌号",
  "hotel.folio.guest.adult": "成人",
  "hotel.folio.guest.child": "儿童",
  male: "男",
  female: "女",
  "hotel.folio.guest.main_guest": "主要住客",
  "hotel.folio.guest.type_guest": "住客类型",
  "hotel.folio.guest.type_document": "证件类型",
  "hotel.folio.guest.mobile": "手机",
  "hotel.folio.guest.address": "地址",
  "hotel.folio.guest.origin_country": "原籍国家",
  "hotel.folio.guest.notes": "备注",
  "hotel.folio.guest.registro_civil": "出生证明",
  "hotel.folio.guest.tarjeta_identidad": "身份证",
  "hotel.folio.guest.cedula_ciudadania": "公民身份证",
  "hotel.folio.guest.tarjeta_extranjeria": "外国人身份证",
  "hotel.folio.guest.cedula_extranjeria": "外国公民身份证",
  "hotel.folio.guest.nit": "税号（NIT）",
  "hotel.folio.guest.add_guest": "添加",
  "hotel.folio.guest.cancel": "取消",
  "hotel.folio.guest.pasaporte": "护照",
  "hotel.folio.guest.tipo_documento_extranjero": "外国证件类型",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "外国税号（NIT）",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "国家",
  "hotel.folio.guest.subdivision": "行政区划",
  "hotel.booking.link_web_checkin": "在线入住链接",
  "hotel.folio.guest.city_co": "城市",
  "hotel.folio.guest.foreign_city": "国外城市",
  "hotel.folio.guest.welcome_tra": "让我们签署住宿登记卡（ARC）",
  "hotel.folio.guest.hello": "您好",
  hotel_tra_register_card: "住宿登记卡（ARC）",
  "msg-introduction": "我们将签署住宿登记卡（ARC）。",
  "hotel.folio.guest.title-modal-select-lan": "选择语言",
  "hotel.folio.guest.btn_finish": "完成",

  "hotel.folio.guest.content_guest": "住客",
  "hotel.folio.guest.content_info_folio": "主要住客信息",
  "hotel.folio.guest.content_contract": "住宿合同",
  "hotel.folio.guest.content_signature": "电子签名",
  "hotel.folio.guest.terms_and_conditions1":
    "我已阅读并同意住宿合同的条款和条件",
  "hotel.folio.guest.terms_and_conditions2": "以及酒店的个人数据处理政策",
  "hotel.folio.guest.guests_no_found": "未找到住客",
  "hotel.folio.guest.accept_contract": "您尚未接受住宿合同",
  "hotel.folio.signature.updated": "签名更新成功",
  "hotel.folio.guest.finish": "欢迎来到酒店！",
  "hotel.folio.guest.finish_tra": "感谢您使用数字化方式完成登记！",
  "hotel.folio.guest.finish_description":
    "通过这个小小的举动，您帮助减少了纸张的使用并保护了地球。每一个行动都很重要。",
  "app.webcheckin.melhos.use_app": "您可以使用我们的应用！最棒的是无需下载 😎",
};
export default zh;
